import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes, FaStar } from "react-icons/fa";

const ReviewModal = ({
  show,
  onClose,
  selectedBook,
  rating,
  setRating,
  reviewText,
  setReviewText,
  handleSubmitReview,
}) => {
  if (!show) return null;

  const handleBackdropClick = (e) => {
    if (e.target.id === "backdrop") {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        id="backdrop"
        className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
        onClick={handleBackdropClick}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-2xl p-8 w-full max-w-md shadow-lg relative"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.8 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-primary transition-colors"
          >
            <FaTimes size={20} />
          </button>

          {/* Title */}
          <h2 className="text-2xl font-semibold text-text-muted mb-4 text-center">
            Review <span className="text-primary">{selectedBook?.bookName}</span>
          </h2>

          {/* Rating */}
          <div className="flex justify-center mb-6">
            {[1, 2, 3, 4, 5].map((star) => (
              <FaStar
                key={star}
                size={28}
                onClick={() => setRating(star)}
                className={`cursor-pointer transition-colors ${
                  star <= rating ? "text-primary" : "text-gray-300"
                }`}
              />
            ))}
          </div>

          {/* Review Textarea */}
          <textarea
            className="w-full h-32 p-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
            placeholder="Write your review here..."
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
          ></textarea>

          {/* Submit Button */}
          <button
            onClick={handleSubmitReview}
            className="w-full bg-primary hover:bg-primary-shade4 text-white font-semibold py-3 mt-6 rounded-xl transition-all duration-300"
          >
            Submit Review
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ReviewModal;
